<template>
  <div class="layout-wrap" :class="!getIsMobile ? 'layout-wrap-home' : ''">
    <el-container class="container-box" :class="getIsMobile ? 'mobile-container' : ''">
      <el-header
        :height="computedHeight"
        v-show="!hideFooter"
        :class="[
          getIsMobile ? 'isApp' : '',
          isTgFullscreen ? 'isTgFullscreen' : '',
          isInTelegramWebApp ? 'isInTelegramWebApp' : '',
        ]"
        id="headerDom"
      >
        <PHeader v-if="!getIsMobile && pHeaderStyle1" />
        <PHeaderStyle2 v-if="!getIsMobile && pHeaderStyle2" />
        <PHeaderStyle3 v-if="!getIsMobile && pHeaderStyle3" />
        <PHeaderStyle4 v-if="!getIsMobile && pHeaderStyle4" />
        <!-- H5头部下载 -->
        <HHeaderDwonload
          v-if="getIsMobile && showDown && !isTgApp"
          @closeDownload="closeDownload"
          :contentObj="contentObj"
        />
        <HHeader v-if="getIsMobile" />
      </el-header>

      <div style="width: 100%" :style="computedStyle"></div>

      <!-- h5菜单  -->
      <div
        v-if="getIsMobile"
        @click="h5NavClose"
        class="h5-menu-bar"
        :class="[
          menuIsShow ? 'menuopen' : '',
          topNavigationTemplate && topNavigationTemplate.menuPosition === 2 ? 'memu-right' : '',
        ]"
      >
        <div class="menu-box" @click.stop=""><navMenu key="navMenu2" :showDown="showDown" /></div>
      </div>

      <div class="main-box" :style="{ height: getIsMobile ? 'auto' : `calc(100vh - ${headerHeight})` }">
        <!-- pc菜单-->
        <div
          class="pc-menu-bar"
          :class="{
            menuopen: menuIsShow,
            left: topNavigationLeft,
            right: topNavigationRight,
          }"
          v-if="showTopNavigation"
          :style="{ height: `calc(100vh - ${headerHeight})` }"
        >
          <navMenu />
        </div>
        <el-main id="mainBox" :style="mainBoxStyle">
          <div
            class="center-box"
            :class="{
              isHome: isHome,
            }"
          >
            <div
              id="main-content"
              class="view-box"
              :class="{
                mobile: getIsMobile,
                isFullLayoutGame: fullLayoutGame,
              }"
            >
              <keep-alive :include="[...$store.state.keepAlivePage, ...cacheKeys1]" :max="10">
                <router-view></router-view>
              </keep-alive>
              <!-- <router-view></router-view> -->
            </div>
          </div>
          <div class="footer-con" v-show="!fullLayoutGame && !hideFooter">
            <Footer />
          </div>
        </el-main>
      </div>
    </el-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import HHeaderDwonload from "./header/h-header-download.vue";
import HHeader from "./header/h-header.vue";
import PHeader from "./header/p-header.vue";
import navMenu from "./sidebar/navMenu.vue";
import { getH5TopTemplate } from "@/lobby_common/api/basic_gen";
import { throttle, debounce } from "@/lobby_common/utils/index.js";
import { getLocalStorage, setLocalStorage } from "@/lobby_common/utils/auth.js";
import Footer from "./footer";
// import Bus from "@/lobby_common/utils/bus.js";
import { cacheKeys } from "@/lobby_common/utils/commonEnum.js";
import PHeaderStyle2 from "./header/p-header-style2.vue";
import PHeaderStyle3 from "./header/p-header-style3.vue";
import PHeaderStyle4 from "./header/p-header-style4.vue";
import { getCacheData } from "@/lobby_common/utils/index.js";
export default {
  components: {
    PHeader,
    HHeader,
    HHeaderDwonload,
    navMenu,
    Footer,
    PHeaderStyle2,
    PHeaderStyle3,
    PHeaderStyle4,
  },
  data: () => ({
    collapse: true,
    isDownload: false,
    contentObj: {},
    localTime: "",
    hideTopDownload: "",
    mHeight: 520,
  }),
  created() {
    // console.log("created");
    this.getH5TopTemplate();
    // console.log(this.$route.path);
    this.localTime = getLocalStorage("closeDownloadTime");
    this.hideTopDownload = getLocalStorage("hideTopDownload");
    window.sendMessageToWebhideTopDownload = () => {
      this.hideTopDownload = getLocalStorage("hideTopDownload");
    };
  },
  mounted() {
    this.resizeHandler = debounce(() => {
      this.handelresize();
    }, 300);
    window.addEventListener("resize", this.resizeHandler);

    // 监听滚动事件
    // this.listenerScroll();

    // this.$nextTick(() => {
    //   document.getElementById("bgVideo").play();
    // });
  },
  computed: {
    fullLayoutGame() {
      return this.$store.getters.getFullLayoutGame;
    },
    hideFooter() {
      return this.$route.name === "gameList" && this.getIsMobile;
    },
    computedHeight() {
      let height;

      // 判断是否是移动端
      if (this.getIsMobile) {
        if (this.showDown) {
          height = this.$px2rem(90); // 如果 showDown 为 true，返回 90px 的高度
        } else {
          height = this.$px2rem(50);
        }
        if (this.isTgFullscreen) {
          height = `calc(${this.$px2rem(
            50
          )} + var(--tg-content-safe-area-inset-top, 0px) + var(--tg-safe-area-inset-top, 0px))`; // 否则返回默认高度
        }
        if (this.isInTelegramWebApp) {
          height = `calc(${this.$px2rem(50)} + var(--tg-safe-area-inset-top, 0px))`; // 如果是 Telegram Web App
        }
        
        // 二级页面逻辑判断
        if(this.$route.name === 'gameList') {
          height = this.$px2rem(0);
        }
      } else {
        height = this.headerHeight;
        if (this.isTgFullscreen) {
          height = `calc(${this.headerHeight} + var(--tg-content-safe-area-inset-top, 0px) + var(--tg-safe-area-inset-top, 0px))`; // 否则返回默认高度
        }
        if (this.isInTelegramWebApp) {
          height = `calc(${this.headerHeight} + var(--tg-safe-area-inset-top, 0px))`; // 如果是 Telegram Web App
        }
      }

      return height;
    },
    computedStyle() {
      return {
        height: this.computedHeight,
      };
    },
    topNavigationTemplate() {
      return this.$store.getters.getPacketConfig?.topNavigationTemplate?.h5 || null;
    },
    topNavigation() {
      // return { style: 3, menuPosition: 1 }
      return this.$store.getters.getPacketConfig?.topNavigationTemplate?.pc || null;
    },
    showTopNavigation() {
      return (
        !this.getIsMobile &&
        this.topNavigation &&
        this.topNavigation.style !== 2 &&
        this.topNavigation.style !== 4 &&
        this.topNavigation.menuPosition !== 0
      );
    },
    topNavigationLeft() {
      return this.topNavigation && this.topNavigation.style !== 2 && this.topNavigation.menuPosition === 1;
    },
    topNavigationRight() {
      return this.topNavigation && this.topNavigation.style !== 2 && this.topNavigation.menuPosition === 2;
    },
    pHeaderStyle1() {
      return this.topNavigation?.style === 1;
    },
    pHeaderStyle2() {
      return this.topNavigation?.style === 2;
    },
    pHeaderStyle3() {
      return this.topNavigation?.style === 3;
    },
    pHeaderStyle4() {
      return this.topNavigation?.style === 4;
    },
    headerHeight() {
      if (this.pHeaderStyle4) return this.$px2rem(105);
      if (this.pHeaderStyle2) return this.$px2rem(140);
      return this.$px2rem(60);
    },
    mainBoxStyle() {
      const style = {
        padding: "0",
      };
      if (this.getIsMobile) {
        return style;
      }
      if (!this.topNavigation) {
        return style;
      }
      // style = 1 and left
      if (this.topNavigationLeft) {
        style.padding = `0px 0px 0px ${this.menuIsShow ? this.$px2rem(310) : this.$px2rem(104)}`;
        // right
      } else if (this.topNavigationRight) {
        style.padding = `0px ${this.menuIsShow ? this.$px2rem(310) : this.$px2rem(104)} 0px 0px`;
      }
      return style;
    },
    cacheKeys1() {
      return cacheKeys.map((key) => key + "1");
    },
    // headerHeight() {
    //   return this.getIsMobile ? (this.showDown ? "84px" : "40px") : "64px";
    // },
    showDown() {
      if (this.hideTopDownload) {
        return false;
      }
      if (!this.login) {
        return this.isDownload;
      }
      const date = new Date();
      const mytime = date.toLocaleDateString();
      return this.contentObj.isShow === "STATUS_BOOL_TRUE" && this.localTime !== mytime;
    },
    login() {
      return this.$store.getters.login;
    },
    isHome() {
      return this.$route.path === "/home";
    },
    isTour() {
      const route = this.$route;
      const ret = ["/other/", "/games/", "/payGame/"].some((f) => route.path.includes(f));
      const tour = getLocalStorage("isTour") && getLocalStorage("isTour") === "isShow";
      // console.log(!ret && tour, ret, tour, "-------isPayNum1-------");
      return !ret && tour;
    },
    lang() {
      return this.$store.getters.getLang;
    },
    ...mapGetters(["menuIsShow", "getIsMobile", "sidebarWidth"]),
  },
  watch: {
    showDown: {
      handler: function () {
        this.handelresize();
      },
      deep: true,
      // immediate: true,
    },
    getIsMobile: {
      handler: function () {
        if (this.getIsMobile) {
          this.setMenuBar(false);
          this.handelresize();
          this.getH5TopTemplate();
        } else {
          //
        }
      },
      deep: true,
      // immediate: true,
    },
    computedHeight: {
      handler: function (height) {
        this.$store.commit("setHeaderHeight", height);
      },
      immediate: true,
    },
  },
  activated() {},
  methods: {
    ...mapActions(["setMenuBar"]),
    h5NavClose() {
      this.setMenuBar(false);
    },
    getH5TopTemplate: throttle(async function () {
      if (!this.getIsMobile) return;
      const { code, data } = await this.getH5TopTmpData();
      if (code === 0) {
        this.contentObj = data || {};
        setLocalStorage("showDown", this.showDown);
      }
    }, 500),
    async getH5TopTmpData() {
      const data = getCacheData('h5top');
      if (data) {
        return {
          code: 0,
          data: data,
        };
      }
      return getH5TopTemplate({});
    },
    closeDownload() {
      this.isDownload = false;

      const dom = document.querySelector(".el-main");
      setLocalStorage("showDown", false);

      if (this.login) {
        const date = new Date();
        const mytime = date.toLocaleDateString();
        setLocalStorage("closeDownloadTime", mytime);
        this.localTime = mytime;
      }
    },

    handelresize() {
      const dom = document.getElementById("headerDom");
      if (!dom) {
        this.flag += 1;
        if (this.flag < 5) {
          setTimeout(() => {
            this.handelresize();
          }, 200);
        }
        //   return;
      }
      if (dom) {
        // if (dom.getBoundingClientRect()?.top < 0) window.scrollTo(0, 0);
        // 20 底部菜单栏有个小凸起
        this.mHeight = window.innerHeight - 110 + 20 - dom.getBoundingClientRect()?.top;
        if (this.showDown) this.mHeight = window.innerHeight - 150 + 20 - dom.getBoundingClientRect()?.top;
      } else {
        this.mHeight = window.innerHeight - 110 + 20;
        if (this.showDown) this.mHeight = window.innerHeight - 150 + 20;
      }
    },
  },
  destroyed() {
    window.removeEventListener("resize", this.handelresize);
  },
};
</script>
<style lang="scss">
.pc-menu-bar {
  width: 64px;
  transition: width 0.2s linear;
  box-sizing: border-box;
  z-index: 3;
  // position: relative;
  position: fixed;
  top: 60px;
  &.right {
    right: 0px;
  }
  &.left {
    left: 0px;
  }
  &.menuopen {
    flex: none;
    // padding-top: 10px;
    width: 270px;
    background: var(--background-100);
    // opacity: 0.92;
  }
}
</style>
<style lang="scss" scoped>
.main-box {
  width: 100%;
  margin: 0 auto;
}
#mainBox {
  // width: 100%;
}
.center-box {
  position: relative;
  display: block;
  width: 100%;
  max-width: 1340px;
  // padding: 0 10px;
  box-sizing: border-box;
  margin: 0 auto;
  zoom: 1;
  z-index: 2;
  overflow: hidden;
  background: var(--background-1500);
  @media (max-width: 768px) {
    background: var(--background-100);
  }
}
.nav-menu-warp {
  height: 100vh;
  overflow: hidden;
  // position: absolute;
  // top: 0;
  // left: 0;
}
.layout-wrap {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  // padding-bottom: 70px;
  box-sizing: border-box;
}
.layout-wrap-home {
  padding-bottom: 0;
}
.container-box {
  width: 100%;
  height: 100%;
}
.el-header {
  padding: 0;
}

.el-footer {
  border-top: 1px solid var(--border-color-100);
  padding: 0 6px;
}

.el-aside {
  box-sizing: border-box;
  line-height: 32px;
  overflow: hidden;
  transition: width 0.6s ease 0s, height 0.3s ease-in 1s;
  overflow-y: scroll;
}

// .el-main {
//   overflow: hidden;
//   overflow-y: scroll;
// }

.center-box.isHome {
  max-width: 100%;
  padding: 0 0px;
}

.view-box {
  position: relative;
  min-height: 800px;
  // max-width: 1340px;
  box-sizing: border-box;
  margin: 0 auto;
  z-index: 2;
  &.mobile {
    min-height: auto;
  }
  &.isFullLayoutGame {
    max-width: 100%;
    max-height: 100%;
    min-height: unset;
  }
}
#appbox {
  height: 850px;
  overflow: hidden;
}

@media screen and (max-width: 767px) {
  #mainBox {
    padding-bottom: 40px;
  }

  .view-box {
    min-height: 600px;
    &.mobile {
      min-height: auto;
    }
  }

  #appbox {
    height: auto;
  }
}
.footer-con {
  position: relative;
  background: var(--background-300);
  z-index: 2;
  @media (max-width: 768px) {
    background: var(--background-301);
  }
  .footerMain {
    padding: 50px 35px 35px 35px;
  }
  &.fullLayoutGame {
    display: none;
  }
}

#headerDom {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 999;
  background: var(--background-200);
  &.isTgFullscreen {
    padding-top: calc(var(--tg-content-safe-area-inset-top, 0px) + var(--tg-safe-area-inset-top, 0px));
    &.isInTelegramWebApp {
      padding-top: calc(var(--tg-safe-area-inset-top, 0px));
    }
  }
}
</style>
